var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValue01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 276.39 251.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e40e87;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 175.08,
    y: 41.08,
    width: 6.53,
    height: 24.5,
    transform: "translate(83.19 -106.66) rotate(42.61)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 154.75,
    y: 28.33,
    width: 6.53,
    height: 24.5,
    transform: "translate(11.34 -30.86) rotate(11.57)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.5,
    y: 24.58,
    width: 6.53,
    height: 24.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.06,
    y: 28.33,
    width: 6.53,
    height: 24.5,
    transform: "translate(-4.81 64.71) rotate(-32.57)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 85.1,
    y: 41.08,
    width: 6.53,
    height: 24.5,
    transform: "translate(-11.83 78.11) rotate(-45)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m185.52,74.75h-109.02l-38.51,42.42,95.77,95.52,95.77-95.52-44.01-42.42Zm3.26,10.41l27,26.33h-45.01l18-26.33Zm-7.44-4.94l-19,30.1-19-30.1h38.01Zm-28,31.27h-45.01l27-26.33,18,26.33Zm-29.82-31.27l-19,30.1-19-30.1h38.01Zm-46.01,4.94l18,26.33h-45.01l27-26.33Zm-27,35.01h50.51l22.5,76.92L50.5,120.17Zm54.01,0h53.51l-24.25,76.92-29.25-76.92Zm36.6,76.92l22.5-76.92h50.51l-73.01,76.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue01);
export default __webpack_public_path__ + "static/media/value-01.8a7bbb1e74d250e029ccc9b23e06d2ce.svg";
export { ForwardRef as ReactComponent };